import { Component, OnInit, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ScoutLogExtended } from '../../../interfaces/scout-log-extended';
import { ScoutLogService } from '../../../services/scout-log.service';

@Component({
    selector: 'app-rename-log-dialog',
    templateUrl: './rename-log-dialog.component.html',
    styleUrls: ['./rename-log-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RenameLogDialogComponent {
  input = '';
  searchedAsset: any;
  selectionMade = false;
  @Output() renamed = false;
  initSqNumber = '';
  draftName = '';
  constructor(
    public dialogRef: MatDialogRef<RenameLogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public log: ScoutLogExtended,
    @Inject(MAT_DIALOG_DATA) public serial: string,
    private _logService: ScoutLogService,
    ) {
      this.input = this.log.serial;
      this.initSqNumber = this.log.sequenceNumber;
      this.draftName = this.log.sequenceNumber;

  }

  renameScout(log: any): boolean {
    const name = this.draftName.trim();
    if (!name || name === this.initSqNumber) { return false; }
    this.selectionMade = true;
    this._logService.updateRename(this.log.id, name);
    this.log.sequenceNumber = name;
    this.renamed = true;
    this.dialogRef.close(true);
    return true;
  }

  onNoClick(): void {
    // if not the unit that you're looking for, suggest rename
    this.dialogRef.close();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
